import {
	SET_GLOBAL_META,
	TOGGLE_SELECTED_ITEM,
	RESET_SELECTED_ITEM,
	SET_CACHE_BUST,
	SAVE_META,
	RESTORE_META,
} from '../actions/MetaActions';

import { FORUM_SUCCESS, FORUM_FETCH } from 'Actions/ForumviewActions';
import { MESSAGES_SUCCESS, MESSAGES_FETCH } from 'Actions/MessagesviewActions';
import { FETCH_ONLINE_USERS_SUCCESS, FETCH_ONLINE_USERS } from 'Actions/OnlineUsersActions';
import { PORTALPAGE_SUCCESS, PORTALPAGE_FETCH } from 'Actions/PortalPageActions';
import { SEARCH_SUCCESS, SEARCH_FETCH } from 'Actions/SearchResultActions';
import { THREAD_SUCCESS, THREAD_FETCH } from 'Actions/ThreadviewActions';
import { USERPROFILE_SUCCESS, USERPROFILE_FETCH } from 'Actions/UserprofileActions';
import { WIDGET_SUCCESS, WIDGET_FETCH } from 'Actions/WidgetActions';
import { FETCH_RELEASE_NOTES, FETCH_RELEASE_NOTES_SUCCESS } from 'Actions/ReleaseNotesActions';

const state = {
	cacheBust: null,
	path: [],
	title: 'Loading...',
	subTitle: null,
	selectedElements: {},
	isLoading: false,
	isFetchingAny: false
};

const initialState = {
	...state,
	prevState: {}
};

let pathName = '';

export default function meta(prevState = initialState, action) {
	switch (action.type) {
		case TOGGLE_SELECTED_ITEM:
			let seletedItem = prevState.selectedElements;

			if( seletedItem[ action.id ] ) { // delete it if it's already there
				delete seletedItem[ action.id ];
			} else { // add it if it is not
				seletedItem[ action.id ] = true;
			}

			return {
				...prevState,
				selectedElements: seletedItem
			};

		case RESET_SELECTED_ITEM:
			return {
				...prevState,
				selectedElements: {}
			};

		case SET_GLOBAL_META:
			return {
				...prevState,
				...action.meta,
				title: action.title,
				subTitle: action.subTitle,
				isLoading: false
			};

		case SET_CACHE_BUST:
			return {
				...prevState,
				cacheBust: action.cacheBust
			};

		case '@@router/LOCATION_CHANGE': // We use this to trigger location change events
			let isLoading = prevState.isLoading ? true : ( pathName !== action.payload.pathname && action.payload.action !== 'REPLACE' );
			pathName = action.payload.pathname;

			return {
				...prevState,
				isLoading: isLoading,
			};

		case 'react-native-navigation-redux-helpers/PUSH_ROUTE':
		case 'react-native-navigation-redux-helpers/REPLACE_AT_INDEX':
			return {
				...prevState,
				isLoading: true
			};

		case SAVE_META:
			return {
				...prevState,
				prevState: {
					...prevState,
					isLoading: false
				}
			};

		case FORUM_FETCH:
		case MESSAGES_FETCH:
		case FETCH_ONLINE_USERS:
		case PORTALPAGE_FETCH:
		case SEARCH_FETCH:
		case THREAD_FETCH:
		case USERPROFILE_FETCH:
		case WIDGET_FETCH:
		case FETCH_RELEASE_NOTES:
			return {
				...prevState,
				isFetchingAny: true
			};

		case FORUM_SUCCESS:
		case MESSAGES_SUCCESS:
		case FETCH_ONLINE_USERS_SUCCESS:
		case PORTALPAGE_SUCCESS:
		case SEARCH_SUCCESS:
		case THREAD_SUCCESS:
		case USERPROFILE_SUCCESS:
		case WIDGET_SUCCESS:
		case FETCH_RELEASE_NOTES_SUCCESS:
			return {
				...prevState,
				isFetchingAny: false
			};

		case RESTORE_META:
			return prevState.prevState || initialState;

		default:
			return prevState;
	}
}


// WEBPACK FOOTER //
// ./common/reducers/meta.js